import { render } from "./Business.vue?vue&type=template&id=9880282e"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
script.render = render

export default script